import PropTypes from 'prop-types';
import React from 'react';

import BasePackageSelector from 'UserRegistration/components/RegistrationSteps/PackageSelector/BasePackageSelector';

//Wrapper component for the package selector for the public registration context
function PublicPackageSelector(props) {

    const propsCopy = Object.assign({}, props);

    //Override props to follow business rules.
    if (props.preselectedSubscriptionItemId || props.preselectedGroupId) {
        propsCopy.displayFreePackages = false;
    }

    //Render the package selector
    return (

        <BasePackageSelector
            {...propsCopy}
        />

    );

}

PublicPackageSelector.propTypes = {
    /** Flag that indicates whether or not packages without a cost should be displayed. */
    displayFreePackages: PropTypes.bool,
    /** A key that corresponds to a property of the registrationModel object. @see UserRegistration.js */
    modelKey: PropTypes.string,
    /** The ID of the package group to preselect. */
    preselectedGroupId: PropTypes.number,
    /** List of preselected subscription item IDs to preselect (nullable)*/
    preselectedSubscriptionItemId: PropTypes.array,
    /** The ID of the purchasing group to pre-select */
    purchasingGroupId: PropTypes.number,
    /** The total number of configurable sections currently loaded in the instance of UserRegistration. */
    sectionCount: PropTypes.number,
    /** The position of this section in relation to other sections in the entire instance of UserRegistration. */
    sectionNumber: PropTypes.number,
    /** The frequency that the pckage selector should default to when it first loads. */
    defaultFrequency: PropTypes.string,
    /** The promotional code. */
    promoCode: PropTypes.string
};

PublicPackageSelector.defaultProps = {
    displayFreePackages: true
};

export default PublicPackageSelector;
